export default {
  updateCategoryIndex({ commit, categoryIndex }) {
    commit('updateCategoryIndex', categoryIndex);
  },
};
